export default "__VITE_ASSET__rDGmKk0a__"